import axios from "axios";

export interface Quintile {
  label: string;
  "revenue-share": number;
  "avg-per-customer": number;
  "customer-count": number;
  "total-discount": number;
}

export interface ComparisonGroup {
  "avg-first-order": number;
  "days-to-second-purchase": number | null;
  "repeat-rate": number;
  "avg-orders": number;
  "avg-12-month-ltv": number;
  "avg-customer-age-days": number | null;
}

export interface Comparison {
  multiplier: number;
  top: ComparisonGroup;
  bottom: ComparisonGroup;
}

export interface CustomerValueData {
  quintiles: Quintile[];
  comparison: Comparison | null;
  // Spearman correlation between each customer's first-order value and
  // their lifetime total spend, computed across the workspace's cohort.
  // Higher = LTV is more predictable from the earliest signal alone;
  // lower = the workspace has signal beyond order value (or genuinely
  // noisy customer behavior). null when the cohort is empty or has
  // insufficient variation to compute a correlation.
  predictability: number | null;
}

export type CohortFilter = "all" | "12m" | "90d";

export const getCustomerValue = async (
  workspaceSlug: string,
  since?: CohortFilter,
): Promise<CustomerValueData> => {
  const params = since && since !== "all" ? { since } : {};
  return (
    await axios.get(`/api/v1/workspaces/${workspaceSlug}/customer-value`, {
      params,
    })
  ).data;
};
